export default __webpack_public_path__ + "static/media/@danimotaoficial.b3d377d5.jpg";